import { useEffect } from "react";
import { PointerEventProps } from "../types/pointerEvent";

export const usePointerEnter = ({
  on = true,
  ref,
  callback,
  reverseCallback,
}: PointerEventProps) => {
  useEffect(() => {
    if (on && callback !== undefined && ref.current !== null) {
      const element = ref.current;

      const handler = (e: PointerEvent) => {
        callback(e);
        if (reverseCallback !== undefined) {
          element.addEventListener("pointerleave", reverseCallback, {
            once: true,
          });
        }
      };

      element.addEventListener("pointerenter", handler);

      return () => {
        element.removeEventListener("pointerenter", handler);
      };
    }
  }, [callback, on, ref, reverseCallback]);
};
